import { TTransformedTenant } from '@/backoffice/features/tenants/hooks/use-tenants-transformer/use-tenants-transformer.types';
import { useReadTenantsLatestSubscriptionsQuery } from '@/backoffice/redux/api/billing-backoffice/billing-backoffice-api';

// Fetched for the whole page in one request and put on the row, so the grid can
// sort by it. `undefined` means not answered yet, `null` none or a failed batch.
export const useTenantSubscriptions = (
  tenants: TTransformedTenant[],
): TTransformedTenant[] => {
  const tenantIds = tenants.map(({ tenantId }) => tenantId);

  const { currentData, isError } = useReadTenantsLatestSubscriptionsQuery(
    { tenantIds },
    { skip: tenantIds.length === 0 },
  );

  // currentData, never data: `data` keeps serving the previous page's result
  // while a new page is in flight.
  const subscriptionsByTenant = new Map(
    currentData?.tenantsLatestSubscriptions.map(
      ({ tenantId, subscription }) => [tenantId, subscription],
    ),
  );
  const isAnswered = !!currentData || isError;

  return tenants.map((tenant) => ({
    ...tenant,
    subscription: isAnswered
      ? (subscriptionsByTenant.get(tenant.tenantId) ?? null)
      : undefined,
  }));
};
